import React, { Suspense } from 'react';
import type { FunctionComponent } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary, ChunkLoadErrorBoundary } from '@trello/error-reporting';
import type { BoardTableViewLabelsPopoverProps } from './BoardTableViewLabelsPopover';

export const LazyBoardTableViewLabelsPopover: FunctionComponent<BoardTableViewLabelsPopoverProps> = (
  props,
) => {
  const BoardTableViewLabelsPopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-table-view-labels-popover" */ './BoardTableViewLabelsPopover'
      ),
    { namedImport: 'BoardTableViewLabelsPopover' },
  );
  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-workflowers', feature: 'Labels Popover' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <BoardTableViewLabelsPopover {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
